import React, { memo } from "react";

const NetworkIcon = memo(({ color = "rgba(60, 60, 60, 0.8)" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M22.5 11.25a0.75 0.75 0 0 1-0.75 0.75h-3v3h0.75a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h0.75v-3H6.75v3h0.75a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h0.75v-3H2.25a0.75 0.75 0 0 1 0-1.5h9v-2.25h-0.75a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-0.75v2.25h9a0.75 0.75 0 0 1 0.75 0.75z" /></svg>
  );
});

export default NetworkIcon;
